import { Component, Input, OnInit } from '@angular/core';
declare var $;
@Component({
  selector: 'app-sw-recently-edit',
  templateUrl: './sw-recently-edit.component.html',
  styleUrls: ['./sw-recently-edit.component.css']
})
export class SwRecentlyEditComponent implements OnInit {

  // 快捷操作：新增实体、新增关系、最近编辑
  @Input() state:string

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    console.log('rencentltEditPage',this.state);
    if(this.state == 'recentlyEdit'){
      $('.recentlyEditBox').css('right','0');
    }else{
      $('.recentlyEditBox').css('right','-660px');
    }
  }

  // 执行关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.recentlyEditBox').css('right','-660px');
  }
}
